import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable } from 'rxjs';
import { CoreHttpService } from 'src/app/providers/core-http/core-http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService extends CoreHttpService {

  private userUrl: string = `${environment.apiUrl}/user`;
  private roleUrl: string = `${environment.apiUrl}/role`;
  private teamUrl: string = `${environment.apiUrl}/team`;

  updateOnlineUsers = new BehaviorSubject<any>([]);
  currentOnlineUsers = this.updateOnlineUsers.asObservable();

  constructor(
    private _http: HttpClient,
    router: Router,
    spinner: NgxSpinnerService
  ) {
    super(_http, router, spinner);
  }

  public getUpdatedOnlineUsers(user: any): void {
    this.updateOnlineUsers.next(user);
  }

  /* User Login with PIN */
  loginWithPin(model: any): Observable<any> {
    return this.post(`${this.userUrl}/LoginWithPin`, model);
  }

  getUserProfileById(userId: number): Observable<any> {
    return this.get(`${this.userUrl}/GetUserProfileById?UserId=${userId}`);
  }

  getDocumentUserList(userId): Observable<any> {
    return this.get(`${this.userUrl}/GetUsersDetail?UserId=${userId}`);
  }

  getUserAgreementFormat(): Observable<any> {
    return this.get(`${this.userUrl}/GetUserAgreementFormat`);
  }

  addUpdateUserAgreements(param): Observable<any> {
    return this.post(`${this.userUrl}/AddUpdateUserAgreements`, param);
  }

  deleteUserMaster(formData: FormData): Observable<any> {
    return this.postFormData(`${this.userUrl}/AddUpdateUserMaster`, formData);
  }

  //User account list
  getUserAccountList(model: any): Observable<any> {
    return this.post(`${this.userUrl}/account-list`, model);
  }

  // Get User Info by Id
  getUserAccountInfoById(model: any): Observable<any> {
    return this.post(`${this.userUrl}/account-info`, model);
  }

  // Create Account
  createUserAccount(param: any): Observable<any> {
    return this.post(`${this.userUrl}/create-account`, param);
  }

  AddUpdateUserMaster(param: any): Observable<any> {
    return this.post(`${this.userUrl}/AddUpdateUserMaster`, param);
  }

  forgotUserPassword(param: any): Observable<any> {
    return this.post(`${this.userUrl}/forgot`, param);
  }

  resetUserPassword(param: any): Observable<any> {
    return this.post(`${this.userUrl}/reset`, param);
  }

  UpdateUserProfile(formData: FormData): Observable<any> {
    return this.postFormData(`${this.userUrl}/UpdateUserProfile`, formData);
  }

  checkIsUsernameExists(userName: string): Observable<any> {
    return this.post(`${this.userUrl}/user-exists?userName=${userName}`, {});
  }

  setActiveInactiveByUserId(model: any): Observable<any> {
    return this.post(`${this.userUrl}/SetActiveInactiveByUserId`, model);
  }

  getUserHistory(model: any): Observable<any> {
    return this.post(`${this.userUrl}/GetUserHistory`, model);
  }

  getUserAccessibilityList(params: any): Observable<any> {
    return this.postParams(`${this.userUrl}/GetUserAccessibilityList`, "", params);
  }

  SetUserAccessibility(model: any) {
    return this.post(`${this.userUrl}/SetUserAccessibility`, model);
  }

  getSingedInUserList() {
    return this.get(`${this.userUrl}/GetSignedInUserList`)
  }

  getUserStatusDetailById() {
    return this.get(`${this.userUrl}/GetUserStatusDetailById`)
  }

  addUpdateSignedUser(param: any): Observable<any> {
    return this.postParams(`${this.userUrl}/AddUpdateSignedInUser`, "", param);
  }

  getDepartmentwiseUser(departmentId: number): Observable<any> {
    return this.get(`${environment.apiUrl}/Common/GetUserListByDepartmentId?departmentId=` + departmentId)
  }

  getTeamWiseUser(teamId: number): Observable<any> {
    return this.get(`${environment.apiUrl}/Common/GetUserListByTeamId?teamId=` + teamId)
  }
}
